import { TextField, makeStyles } from '@material-ui/core';
import {
    buildLiveChatMessageFromMe,
    buildMessageConnecting,
    postMessage,
    postMessageLiveChat
} from '../handler/ChatBoxHandler';
import { Autocomplete } from '@material-ui/lab';
import React from 'react';
import OverFlowTooltipWithTabsMui from '@/component/common/OverFlowTooltipWithTabsMui';
import { useState, useEffect } from 'react';
import Utils from '@/common/utils/utils';
import Constant from '@/common/constant/Constant';
import { getPublicPageTimezone } from '@/common/utils/timezoneUtils';
import crypto from 'crypto-js';
import { useRecoilState } from 'recoil';
import {
    updatePreviewSettingAtom
} from '@/state/atom/chatBotPreview';

export default function MessageTime({ messages, message, index, chatbotLogo, chatBotName,listAgentData, isModePreview }) {

    const [creatorInfo,setCreatorInfo] = useState({
        name: chatBotName,
        avatar: chatbotLogo ? chatbotLogo : Constant.SETTING_CHAT_BOT.LOGO_ICON_DEFAULT,
        isDisplayNameLogo: false,
        shortName: ''
    })

    useEffect(() => {
        let agentData = listAgentData?.find(agent => {
            return agent.id === message.creatorId
        });
        let creatorInfoClone = {...creatorInfo}
        if(!Utils.isEmptyObject(agentData)){
            let name = Utils.getFullNameOfUser(Constant.LANGUAGE_TYPE.JP,agentData,false);
            if(!Utils.isEmptyString(name)) creatorInfoClone.name = name;
            if(!Utils.isEmptyString(agentData.image)){
                creatorInfoClone.avatar = renderLinkAvatar(agentData.image)
                creatorInfoClone.isDisplayNameLogo = false;
            }else{
                const shortName = Utils.getShortName(Utils.getTextByLanguage(Constant.LANGUAGE_TYPE.JP,agentData.lastName));
                creatorInfoClone.isDisplayNameLogo = true;
                creatorInfoClone.shortName = shortName
            };
            setCreatorInfo(creatorInfoClone)
        }
    },[message,listAgentData])

    const renderLinkAvatar = (key) => {
        let s3Path = key;
    
        let uriObj = {};
        let projectList = [];
        let orgHasReadPermission = [];
        let userHasReadPermission = [];
    
        uriObj = {
            projectList,
            orgHasReadPermission,
            userHasReadPermission,
            keyFile: `/public/${s3Path}`,
            publicAll: true
        };
    
        const enCodeUriObj = encodeURIComponent(
            crypto.AES.encrypt(JSON.stringify(uriObj), Constant.S3_URL_AES_ENCODE_KEY).toString()
        );
        const newUri = `/${enCodeUriObj}`;
        return `${process.env.REACT_APP_CLOUD_FRONT_URL}${newUri}`;
    } 

    const isDisplayTimeMessage = () => {
        if(index=== 0) return true;
        if(message.messageType === Constant.DEFAULT_CHATBOT_MESSAGE_TYPE.END_LIVE_CHAT) return false
        if(message.messageType !== Constant.DEFAULT_CHATBOT_MESSAGE_TYPE.LIVE_CHAT && message.messageType !== Constant.DEFAULT_CHATBOT_MESSAGE_TYPE.LIVE_CHAT_MENTION && message.messageType !== Constant.DEFAULT_CHATBOT_MESSAGE_TYPE.FILE_UPLOADED && message.messageType !== Constant.DEFAULT_CHATBOT_MESSAGE_TYPE.LIVE_CHAT_FORM_ME && message.messageType !== Constant.DEFAULT_CHATBOT_MESSAGE_TYPE.AGENT_MESSAGE ) return true
        if((message.isFromMe && !messages[index-1]?.isFromMe) || (!message.isFromMe && messages[index-1]?.isFromMe) || message.creatorId !== messages[index-1]?.creatorId ) return true;
        
        const dateOfMessage = new Date(Number(message.idMessage));
        const dateOfPreviousMessage = new Date(Number(messages[index-1]?.idMessage));

        if (
            dateOfMessage.getFullYear() !== dateOfPreviousMessage.getFullYear() ||
            dateOfMessage.getMonth() !== dateOfPreviousMessage.getMonth() ||
            dateOfMessage.getDate() !== dateOfPreviousMessage.getDate() ||
            dateOfMessage.getHours() !== dateOfPreviousMessage.getHours() ||
            dateOfMessage.getMinutes() !== dateOfPreviousMessage.getMinutes()
        ) {
            return true
        }


        return false
    }
    const [previewSetting, setPreviewSetting] = useRecoilState(updatePreviewSettingAtom);

    return (
        isDisplayTimeMessage()?
        <>
            {' '}
            {!message.isFromMe &&
                message.messageType !== Constant.DEFAULT_CHATBOT_MESSAGE_TYPE.CONNECTING && (
                    <div className="chat-content">
                        <div className="logo-chatbot-img">
                           { creatorInfo.isDisplayNameLogo ? <div
                                className="assignee-icon-chatbot"
                            >
                                {creatorInfo.shortName}
                            </div>
                      : <img src={isModePreview ? previewSetting.logo : creatorInfo.avatar} alt="logo" className="logo-chatbot-input" /> }
                        </div>
                        <OverFlowTooltipWithTabsMui value={isModePreview ? previewSetting?.chatbotName : creatorInfo.name} className="chatbot-name" />
                        <div className="time-chatbot">
                             {message.dateTime || (Number.isFinite(Number(message.idMessage)) ? Utils.formatDateTime(new Date(Number(message.idMessage)).toISOString(), 'YYYY/MM/DD HH:mm', getPublicPageTimezone()) : '')}
                        </div>
                    </div>
                )}
            {message.isFromMe && (
                <div className="time-chatbot">
                    {message.dateTime || (Number.isFinite(Number(message.idMessage)) ? Utils.formatDateTime(new Date(Number(message.idMessage)).toISOString(), 'YYYY/MM/DD HH:mm', getPublicPageTimezone()) : '')}
                </div>
            )}
        </> : <></>
    );
}
